import React, { useState, useRef } from 'react';
import './ProfileClickEgg.css';

export const MESSAGES = [
    "Hey!",
    "Nice to meet you!",
    "Hm... do you need something?",
    "Ok, this is getting weird...",
    "Are you... clicking me for fun?",
    "I mean, I DO incremental games. But I'm not one of them.",
    "Ok, ok. I'll tell you a secret. There are some achievements hidden in this web. 10 of them.",
    "Yep. So there you have, an actual game. Kinda. It's more of an interactive experience, really.",
    "If you keep clicking me, I'll even give you one of them.",
    "But it won't be easy, of course. You wanted a game :)",
    "Let's start. Click me 10 times, starting... now!",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "Wait. I have to go for a moment.",
    "...",
    "...",
    "...",
    "...",
    "Ups, sorry! I forgot about you. I'm back.",
    "Well, what were we talking about?",
    "Oh, right. The clicks. You are doing great. You click so well!",
    "You must be a clicking pro. Haven't seen anyone click like that before.",
    "It's a legendary clicking performance. You click better than my fath-- Oh, sorry? What's that?",
    "Oh. The achievement. Yeah, the achievement.",
    "Right. I have to finish counting, or the achievement won't unlock. My fault.",
    "9",
    "10",
];

const FALLBACK = "Ok, I literally have nothing left to say. You won. No more achievements on clicking me, I promise. Go play Astro Prospector, or something :)";

const ProfileClickEgg = ({ onUnlock }) => {
    const [clickCount, setClickCount] = useState(0);
    const [bubble, setBubble] = useState(null);
    const bubbleTimer = useRef(null);

    const handleClick = () => {
        const newCount = clickCount + 1;
        setClickCount(newCount);

        const isFallback = newCount > MESSAGES.length;
        const message = isFallback ? FALLBACK : MESSAGES[newCount - 1];

        clearTimeout(bubbleTimer.current);
        setBubble(message);

        if (isFallback) {
            bubbleTimer.current = setTimeout(() => setBubble(null), 10000);
        }

        if (newCount === MESSAGES.length) {
            onUnlock();
        }
    };

    return (
        <div className="profile-egg-wrapper">
            {bubble && (
                <div className="profile-egg-bubble" key={clickCount}>
                    {bubble}
                </div>
            )}
            <div className="profile-image" onClick={handleClick} />
        </div>
    );
};

export default ProfileClickEgg;
